import CardBody from 'components/Card/CardBody';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Check from '@material-ui/icons/Check';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import { Tooltip } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import FormImageUpload from 'components/FormImageUpload/FormImageUpload';
import React from 'react';
import CardWrapper from 'components/Card/CardWrapper';
import InfoWithTooltip from 'components/InfoWithTooltip/InfoWithTooltip';
import { Trans } from 'react-i18next';
import InfoIconTooltip from 'components/InfoIconTooltip/InfoIconTooltip';
import EXTERNAL_URLS from 'constants/externalUrls';
import makeStyles from '@material-ui/styles/makeStyles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';

// eslint-disable-next-line @stylistic/line-comment-position -- FIXME
const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

const useStyles = makeStyles({
  ...extendedFormsStyle,
  ...buttonsStyle,
  labelWrapper: {
    display: 'flex',
  },
  tooltipWrapper: {
    marginLeft: '10px',
    display: 'inline-block',
  },
  imagesWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    textAlign: 'center',
  },
  tooltipList: {
    marginBlockStart: '0',
    marginBlockEnd: '0',
    paddingInlineStart: '1.5em',
  },
});

const BannerSettings = ({
  t,
  state,
  handleInputChange,
  handleToggle,
  getImage,
  removeImage,
}) => {
  const classes = useStyles();

  return (
    <CardWrapper title={t('brandCfg.view.orderForm')}>
      <CardBody>
        <GridContainer>
          <GridItem md={6}>
            <FormTextInput
              multiline={true}
              rows={3}
              rowsMax={10}
              label={
                <div className={classes.labelWrapper}>
                  <span>{t('brandCfg.captionInBanner')}</span>
                  <div className={classes.tooltipWrapper}>
                    <Tooltip
                      title={
                        <>
                          <p>{t('brandCfg.captionInBannerTooltip')}</p>
                          {`${t(
                            'brandCfg.etc'
                          )} <div style="margin: 30px; max-width: 50%">${t(
                            'brandCfg.captionInBannerTooltip.example'
                          )}</div>`}
                        </>
                      }
                      placement="right"
                    >
                      <Info fontSize="small" />
                    </Tooltip>
                  </div>
                </div>
              }
              classes={classes}
              name="newOrderInfoTitle"
              value={state.newOrderInfoTitle}
              handleChange={handleInputChange}
              inputSize={12}
              maxLength={160}
            />
            <FormTextInput
              label={
                <div className={classes.labelWrapper}>
                  <span>{t('brandCfg.textUnderCaption')}</span>
                  <div className={classes.tooltipWrapper}>
                    <Tooltip
                      title={
                        <>
                          <p>{t('brandCfg.captionInBannerTooltip')}</p>
                          {`${t(
                            'brandCfg.etc'
                          )} <div style="margin: 30px; max-width: 50%">${t(
                            'brandCfg.captionInBannerTooltip.example'
                          )}</div>`}
                        </>
                      }
                      placement="right"
                    >
                      <Info fontSize="small" />
                    </Tooltip>
                  </div>
                </div>
              }
              classes={classes}
              name="newOrderInfoDescription"
              value={state.newOrderInfoDescription}
              handleChange={handleInputChange}
              inputSize={12}
              maxLength={1000}
              rows={3}
              rowsMax={20}
              multiline={true}
            />
          </GridItem>

          <GridItem md={6}>
            <FormControlLabel
              control={
                <Checkbox
                  onClick={() => handleToggle('newOrderInfoEnabled')}
                  checked={state.newOrderInfoEnabled}
                  checkedIcon={<Check className={classes.checkedIcon} />}
                  icon={<Check className={classes.uncheckedIcon} />}
                  classes={{
                    checked: classes.checked,
                    root: classes.checkRoot,
                  }}
                />
              }
              label={t('brandCfg.infoBannerShow.short')}
            />
            <div className={classes.imagesWrapper}>
              <div>
                <FormImageUpload
                  stateName="newOrderInfoBannerDesktop"
                  buttonText={t('common.shared.select')}
                  getImage={getImage}
                  imgId="desktop-banner"
                  label={t('brandCfg.bannerPanorama.label')}
                  labelAdditionalContent={
                    <InfoWithTooltip
                      title={
                        <Trans
                          i18nKey="brandCfg.bannerPanorama.tooltip"
                          components={{
                            ul: <ul className={classes.tooltipList} />,
                            li: <li />,
                          }}
                        />
                      }
                      link={EXTERNAL_URLS.bannerImage}
                      linkText={t('brandCfg.bannerTooltip.linkText')}
                    />
                  }
                  removeImage={removeImage}
                  previewUrl={state.newOrderInfoBannerDesktopUrl}
                  maxFileSize={MAX_FILE_SIZE}
                  proportionsConstraint={[1, 3]}
                />
              </div>
              <div>
                <FormImageUpload
                  stateName="newOrderInfoBannerMobile"
                  buttonText={t('common.shared.select')}
                  getImage={getImage}
                  imgId="mobile-banner"
                  label={t('brandCfg.bannerPortrait.label')}
                  labelAdditionalContent={
                    <InfoIconTooltip
                      title={
                        <Trans
                          i18nKey="brandCfg.bannerPortrait.tooltip"
                          components={{
                            ul: <ul className={classes.tooltipList} />,
                            li: <li />,
                          }}
                        />
                      }
                    />
                  }
                  removeImage={removeImage}
                  previewUrl={state.newOrderInfoBannerMobileUrl}
                  maxFileSize={MAX_FILE_SIZE}
                  proportionsConstraint={[5, 4]}
                />
              </div>
            </div>
          </GridItem>
        </GridContainer>
      </CardBody>
    </CardWrapper>
  );
};

export default BannerSettings;
